import { createReducer, makeActionCreator } from 'utils/reduxCreators';
import {
  fetchAccountInfo,
  fetchAllTransactions,
  downloadTransactionsService,
} from 'services/transactions';
import { updateAppLoading } from './meta';

export const RECEIVED_ALL_TRANSACTIONS =
  'transactions/RECEIVED_ALL_TRANSACTIONS';
export const RECEIVED_ACCOUNT_INFOR = 'transactions/RECEIVED_ACCOUNT_INFOR';
export const DOWNLOADED_ALL_TRANSACTIONS =
  'transactions/DOWNLOADED_ALL_TRANSACTIONS';
export const REST_TRANSACTION_PAGE = 'transactions/REST_TRANSACTION_PAGE';

const initialState = {
  accountInfor: {},
  transactions: {},
};

export default createReducer(initialState, {
  [RECEIVED_ACCOUNT_INFOR]: (state, { payload }) => {
    return {
      ...state,
      accountInfor: payload,
    };
  },
  [RECEIVED_ALL_TRANSACTIONS]: (state, { payload }) => {
    return {
      ...state,
      transactions: payload,
    };
  },
  [DOWNLOADED_ALL_TRANSACTIONS]: (state, { payload }) => {
    return {
      ...state,
      downloaded: payload,
    };
  },
  [REST_TRANSACTION_PAGE]: (state) => {
    return {
      ...state,
      transactions: {},
      accountInfor: {},
    };
  },
});

export const getAccountInfo = (adfitNo) => async (dispatch) => {
  try {
    dispatch(updateAppLoading(true));
    const result = await fetchAccountInfo(adfitNo);
    dispatch({ type: RECEIVED_ACCOUNT_INFOR, payload: result });
    dispatch(updateAppLoading(false));
  } catch (err) {
    dispatch(updateAppLoading(false));
    throw err;
  }
};

export const getAllTransactions = (adfitNo) => async (dispatch) => {
  try {
    dispatch(updateAppLoading(true));
    const result = await fetchAllTransactions(adfitNo);
    dispatch({ type: RECEIVED_ALL_TRANSACTIONS, payload: result });
    dispatch(updateAppLoading(false));
  } catch (err) {
    dispatch(updateAppLoading(false));
    throw err;
  }
};

export const downloadTransactions = (adfitNo) => async (dispatch) => {
  try {
    dispatch(updateAppLoading(true));
    await downloadTransactionsService(adfitNo);
    dispatch({ type: DOWNLOADED_ALL_TRANSACTIONS, payload: {} });
    dispatch(updateAppLoading(false));
  } catch (err) {
    dispatch(updateAppLoading(false));
    throw err;
  }
};

export const resetTransPage = makeActionCreator(REST_TRANSACTION_PAGE);
